// UPDATE WITH DATES OF FESTIVAL - drives banner, terms and conditions, etc.

// start date is currently set to september 12th, at 4pm PST
const START_DATE = new Date("2026-07-17T16:00:00-07:00");

// end date is september 14th, 2025 at 4pm PST
const END_DATE = new Date("2026-07-19T16:00:00-07:00");

const MONTH = new Date(START_DATE).toLocaleString("default", {
  month: "long",
});
const START_DAY_OF_FESTIVAL = new Date(START_DATE).getDate();
const END_DAY_OF_FESTIVAL = new Date(END_DATE).getDate();
const YEAR = new Date(START_DATE).getFullYear();

export {
  END_DATE,
  MONTH,
  START_DAY_OF_FESTIVAL,
  END_DAY_OF_FESTIVAL,
  YEAR,
  START_DATE,
};
